import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/faqs/page.tsx");
